module.exports = __webpack_public_path__ + "img/loginBg.c4eb1a73.png";